import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import User from '@utils/storage/user'
import ToastMessage from '@components/ToastMessage/ToastMessage'
import { t } from '@utils/translations'

function RestrictPrivateRoute() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!User.hasMasterPrivileges()) {
      toast(<ToastMessage message={t('messages.unauthorizedError')} variant='danger' />)

      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Outlet />
}

export default RestrictPrivateRoute
